import { render, staticRenderFns } from "./ProjectResourceAllocationsPage.vue?vue&type=template&id=356df48d&scoped=true"
import script from "./ProjectResourceAllocationsPage.vue?vue&type=script&lang=ts"
export * from "./ProjectResourceAllocationsPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectResourceAllocationsPage.vue?vue&type=style&index=0&id=356df48d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356df48d",
  null
  
)

export default component.exports